import { minuteMs, secondMs } from "verdi-common/timeConstants";

// Values double as interval lengths (ms) passed directly to msUntilNextBoundary.
export enum CLOCK_CADENCE {
    SECONDS_5 = 5 * secondMs,
    SECONDS_15 = 15 * secondMs,
    SECONDS_30 = 30 * secondMs,
    MINUTES_1 = 60 * secondMs,
    MINUTES_5 = 5 * minuteMs,
}

// Numeric enums include reverse-mapping string keys in Object.values(); filter them out.
export const ALL_CADENCES = Object.values(CLOCK_CADENCE).filter((v): v is CLOCK_CADENCE => typeof v === "number");
